import { useEffect, useSyncExternalStore } from 'react';

/**
 * Tracks whether a dashboard shell (DashboardLayout / NarrowDashboardLayout)
 * is mounted, so `SiteChatWidget` can hide the public-site chat bubble inside
 * the product without maintaining a list of every dashboard route. Dual-mode
 * pages (marketing shell for visitors, dashboard chrome for members) get the
 * right answer for free.
 */
let dashboardChromeCount = 0;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach((listener) => listener());

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => dashboardChromeCount > 0;
const getServerSnapshot = () => false;

/** Call once in every dashboard layout component. */
export function useDashboardChromePresence(): void {
  useEffect(() => {
    dashboardChromeCount += 1;
    notify();
    return () => {
      dashboardChromeCount -= 1;
      notify();
    };
  }, []);
}

export function useDashboardChromeMounted(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
